// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  width: 100%;
  height: 100%;
}
:host .container .card-html .card-content {
  width: 100% !important;
  height: 100% !important;
}
:host .container .card-content {
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: -moz-fit-content;
  width: fit-content;
}
:host .container .card-iframe-edit span {
  color: black;
  display: block;
  text-align: center;
}
:host .container .card-content div {
  width: 100% !important;
  height: 100% !important;
}
:host .container .card-tool {
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  position: absolute;
  bottom: -15px;
  padding-left: 10px;
  font-size: 11px;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 194px;
  border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/cards-view/cards-view.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/cards-view/cards-view.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,YAAA;ACAR;ADEQ;EACI,sBAAA;EACA,uBAAA;ACAZ;ADGQ;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EAAA,kBAAA;ACDZ;ADKY;EACI,YAAA;EACA,cAAA;EACA,kBAAA;ACHhB;ADOQ;EACI,sBAAA;EACA,uBAAA;ACLZ;ADQQ;EACI,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,kBAAA;ACNZ","sourcesContent":[":host {\n    .container {\n        width: 100%;\n        height: 100%;\n\n        .card-html .card-content {\n            width: 100% !important;\n            height: 100% !important;\n        }\n\n        .card-content {\n            margin: 0 auto;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            width: fit-content;\n        }\n\n        .card-iframe-edit {\n            span {\n                color: black;\n                display: block;\n                text-align: center;\n            }\n        }\n\n        .card-content div {\n            width: 100% !important;\n            height: 100% !important;\n        }\n\n        .card-tool {\n            background-color: rgba(0,0,0,0.6);\n            color:white;\n            position:absolute;\n            bottom: -15px;\n            padding-left: 10px;\n            font-size: 11px;\n            left: 50%;\n            transform: translate(-50%, -50%); \n            width: 194px;\n            border-radius: 2px;\n        }\n    }\n}",":host .container {\n  width: 100%;\n  height: 100%;\n}\n:host .container .card-html .card-content {\n  width: 100% !important;\n  height: 100% !important;\n}\n:host .container .card-content {\n  margin: 0 auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: fit-content;\n}\n:host .container .card-iframe-edit span {\n  color: black;\n  display: block;\n  text-align: center;\n}\n:host .container .card-content div {\n  width: 100% !important;\n  height: 100% !important;\n}\n:host .container .card-tool {\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  position: absolute;\n  bottom: -15px;\n  padding-left: 10px;\n  font-size: 11px;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 194px;\n  border-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
